import { useParams, useSearch } from '@tanstack/react-router'
import { useCompanyStore, useFacilityStore } from '../_stores'

/**
 * Reads applicationId from route params and companyId/facilityId from either
 * route params, search params, or Zustand stores (for company-scoped routes).
 * Also returns slugs for link generation (routes use $companySlug/$facilitySlug).
 */
export function useApplicationParams() {
  const routeParams = useParams({ strict: false }) as Record<string, string | undefined>
  const searchParams = useSearch({ strict: false }) as Record<string, string | undefined>

  const storeCompany = useCompanyStore((s) => s.company)
  const storeFacility = useFacilityStore((s) => s.currentFacility)

  return {
    applicationId: routeParams.applicationId ?? '',
    companyId: searchParams.companyId ?? storeCompany?.id ?? '',
    facilityId: searchParams.facilityId ?? storeFacility?.id ?? '',
    companySlug: routeParams.companySlug ?? storeCompany?.slug ?? '',
    facilitySlug: routeParams.facilitySlug ?? storeFacility?.slug ?? '',
  }
}
